// jobq-api's operator-session routes (Shipping hub, Phase 1; jobq-api main.py next to /auth/pin):
//   POST /auth/operator-session        {pin}   -> {token, user_id, name, role, source, expires_at, ttl_sec}
//                                               401 Invalid PIN | 429 lockout | 400 a 16-digit "PIN"
//   POST /auth/operator-session/check  {token} -> {user_id, name, role, source, expires_at} | 401 expired
//   POST /auth/operator-session/end    {token} -> {ok, found}
// None of them ever throws: {ok, ...} | {ok: false, status, message} (message = the sentence to show).
// A PIN or token never goes in a URL.
import config from '../../config.js';
import { detailToString } from '../../utils/apiError';

const base = () => config.API_BASE_URL;

async function post(path, body) {
  try {
    const res = await fetch(`${base()}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    let data = null;
    try { data = await res.json(); } catch (_) { data = null; }
    if (res.ok) return { ok: true, status: res.status, data: data || {} };
    const detail = data && typeof data === 'object' ? data.detail : null;
    const message = (detail && typeof detail === 'object' && detail.message) || detailToString(detail) || `HTTP ${res.status}`;
    return { ok: false, status: res.status, message };
  } catch (_) {
    return { ok: false, status: 0, message: 'Could not reach JobQ.' };
  }
}

/** Sign in with a typed PIN. {ok, session} | {ok:false, status, message}. */
export async function startSession(pin) {
  const r = await post('/auth/operator-session', { pin });
  if (!r.ok) {
    const message = r.status === 401 ? "That PIN isn't anyone's. Try again." : r.message;
    return { ok: false, status: r.status, message };
  }
  const d = r.data;
  return {
    ok: true,
    session: {
      token: d.token, user_id: d.user_id, name: d.name, role: d.role,
      source: d.source || 'pin', expires_at: d.expires_at,
    },
  };
}

/** Who a token is and when it ends. {ok, info} | {ok:false, status, message, expired}. */
export async function checkSession(token) {
  const r = await post('/auth/operator-session/check', { token });
  if (!r.ok) return { ok: false, status: r.status, message: r.message, expired: r.status === 401 };
  return { ok: true, info: r.data };
}

/** End a token now (sign out / switch person). Failing to reach JobQ just lets it run out. */
export async function endSession(token) {
  if (!token) return { ok: true };
  const r = await post('/auth/operator-session/end', { token });
  return r.ok ? { ok: true, found: !!r.data.found } : { ok: false, status: r.status, message: r.message };
}
